
import React from "react"
import { useContext } from "react"

import "../store.css"
import { CartContext } from "../../context/CartContext"

function CartItem(props) {

    const { cartItems, addToCart, removeFromCart } = useContext(CartContext)
    return(

        <div className="cart">
        <div className="cartItem">
        <img src={props.item.url} width="180px" height="170px" style={{padding:"0px 15px"}} />
        <div className="description">
            <p><b>{props.item.name}</b></p>
            <p>Price: {`$ ${props.item.price} `}</p>
            <div className="countHandler">
        <button className="quantityBtns" onClick={()=>addToCart(props.item._id)}>+</button>
        <span className="quantity">Quantity: {cartItems[props.item._id]}</span>
        <button className="quantityBtns" onClick={()=>removeFromCart(props.item._id)}>-</button>
        </div>
        </div> 
        </div>
        </div>
    )

}

export default CartItem
